import { useRecoilTask } from 'recoil-toolkit';

import { usersState } from './atoms';
import { getUsersTask } from './tasks';

export const useUsersList = () => useRecoilTask(getUsersTask, [], {
  dataSelector: usersState,
  errorStack: true,
});
